import { Button } from "@/components/ui/button";

import {
  HumanConfiguration,
  ReportCell,
  ReportColumn,
  SliderUIElement,
} from "@/types/evaluate";
import { useState } from "react";
import { usePatchReportCell } from "../hooks/usePatchReportCell";
import { HumanInputUIComponent } from "./HumanUIComponent";
import { StatusCell, StatusCellType } from "./StatusCell";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

const getTextValue = (
  uiComponent: string,
  value?: string | number,
  config?: HumanConfiguration,
) => {
  if (value === null || value === undefined) return "-";

  switch (uiComponent) {
    case "text":
      return value;
    case "slider":
      const sliderConfig = config?.ui_element as SliderUIElement;
      return `${value} / ${sliderConfig.max}`;
    case "number":
      return value;
    default:
      return "-";
  }
};

export const HumanInputCell = ({
  cell,
  column,
}: {
  cell: ReportCell;
  column: ReportColumn;
}) => {
  const config: HumanConfiguration = column.configuration;
  const dataType = config?.data_type;
  const uiComponent = config?.ui_element.component;
  const cellValue = cell.value?.value;
  const [value, setValue] = useState<any>(cellValue);
  const status = cell.status.toLowerCase() as StatusCellType;
  const isCompleted = status === "completed";

  const { patchReportCell, isLoading } = usePatchReportCell(cell?.id);

  return (
    <div className="flex h-full flex-col items-center justify-center gap-y-2">
      <div className="flex flex-col items-center justify-center px-2 py-1">
        <StatusCell status={isLoading ? StatusCellType.LOADING : status} />
      </div>
      <span className="max-w-[256px] text-xs">
        {getTextValue(uiComponent, cellValue, config)}
      </span>
      <Popover>
        <PopoverTrigger>
          <div className="flex h-full flex-col items-center justify-center px-2 py-1">
            <Button size="sm" variant="outline">
              Edit
            </Button>
          </div>
        </PopoverTrigger>
        <PopoverContent className="flex flex-col items-center justify-center gap-y-2">
          <HumanInputUIComponent
            uiComponent={uiComponent}
            dataType={dataType}
            config={config}
            value={value}
            setValue={setValue}
          />
          <Button
            size="sm"
            variant="outline"
            onClick={() => {
              patchReportCell({
                value: value,
              });
            }}
            isLoading={isLoading}
          >
            {isCompleted ? "Overwrite" : "Save"}
          </Button>
        </PopoverContent>
      </Popover>
    </div>
  );
};
